/**
 * Common CSS properties that should not be forwarded to DOM elements
 * when using styled-components
 */
const COMMON_STYLED_PROPS = [
  // Typography
  "textTransform",
  "textDecoration",
  "fontSize",
  "fontWeight",
  "weight",
  "lineHeight",

  // Colors
  "color",
  "backgroundColor",
  "borderColor",

  // Spacing (styled-system)
  "m",
  "mt",
  "mr",
  "mb",
  "ml",
  "mx",
  "my",
  "margin",
  "marginTop",
  "marginRight",
  "marginBottom",
  "marginLeft",
  "p",
  "pt",
  "pr",
  "pb",
  "pl",
  "px",
  "py",
  "padding",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",

  // Layout
  "display",
  "width",
  "height",
  "maxWidth",
  "maxHeight",
  "minWidth",
  "minHeight",

  // Flexbox
  "alignItems",
  "justifyContent",
  "flexDirection",
  "flexWrap",
  "flex",
  "flexGrow",
  "flexShrink",
  "flexBasis",

  // Position
  "position",
  "top",
  "right",
  "bottom",
  "left",
  "zIndex",

  // Border
  "border",
  "borderWidth",
  "borderStyle",
  "borderRadius",

  // Component specific props
  "variant",
  "size",
  "disabled",
  "active",
  "loading",
  "error",
  "success",
  "warning",

  // Dodaj propsy z błędów
  "productView",
  "textColor",
  "colorVariants",
  "currentSlide",
  "slideCount",
  "isExpanded",
  "fullWidth",
];

/**
 * Creates a shouldForwardProp function for styled-components that filters out
 * common CSS-in-JS props and any additional custom props
 *
 * @param additionalProps - Array of additional prop names to filter out
 * @returns shouldForwardProp function for styled-components
 */
export const createShouldForwardProp = (
  additionalProps: string[] = [],
  include$Props: boolean = true,
) => {
  const allFilteredProps = [...COMMON_STYLED_PROPS, ...additionalProps];

  return (prop: string) => {
    if (include$Props && prop.startsWith("$")) {
      return false;
    }

    if (allFilteredProps.includes(prop)) {
      return false;
    }

    return true;
  };
};

/**
 * Default shouldForwardProp function that filters out common styled-components props
 */
export const defaultShouldForwardProp = createShouldForwardProp();
